<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row :gutter="10" class="searchSection">
                <el-col :span="5">
                    <el-card>
                        <el-row class="searchSection">
                            <el-col :span="12">
                                <label class="item-title">常用规则</label>
                            </el-col>
                            <el-col :span="12">
                                <el-button v-if="Acs('/knowledge-base/create')" size="small" type="primary" @click="showDialog()">新增</el-button>
                            </el-col>
                        </el-row>
                        <el-divider class="customr-divider"></el-divider>
                        <el-table
                            :data="list" 
                            ref="singleTable" 
                            height="752" 
                            highlight-current-row
                            @row-click="setCurrent"
                            :show-header="false"
                            v-loading="loading">
                            <el-table-column prop="title"></el-table-column>
                            <el-table-column width="40">
                                <template slot-scope="scope">
                                    <el-button v-if="Acs('/knowledge-base/delete')" type="text" @click="deleteItem(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
                <el-col :span="19">
                    <el-card>
                        <el-row class="searchSection">
                            <el-col :span="3" :offset="21">
                                <el-button v-if="Acs('/knowledge-base/update')" size="small" type="primary" @click="showDialog(true)" :disabled="form.id <= 0">编辑</el-button>
                            </el-col>
                        </el-row>
                        <el-divider class="customr-divider"></el-divider>
                        <div v-if="form.id > 0">
                            <el-row style="text-align: center">
                                <h2>{{form.title}}</h2>
                                <h5>最近更新：{{form.updated_at}}</h5>
                            </el-row>
                            <div class="ql-editor" v-html="form.content"></div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-dialog :title="is_edit ? '编辑' : '新增'" :visible.sync="dialogVisible" width="80%">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="form.title" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="弹窗提示" prop="send_message">
                    <el-radio-group v-model="form.send_message">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="正文" prop="content">
                    <QuillEditor v-if="dialogVisible" v-model="form.content" :content="form.content" @change="editorChange"></QuillEditor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="create()" :loading="form_loading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style>
.customr-divider {
    margin: 10px 0; /* 上边距10px，下边距10px */
}
</style>
<script>
import KnowledgeBaseService from "~/services/KnowledgeBase";
import QuillEditor from "~/widgets/QuillEditor.vue";
export default {
    name: "rule-list",

    components: {
        QuillEditor
    },

    data() {
        return {
            list: [],
            loading: false,
            searcheModel: {},
            form_loading: false,
            is_edit: false,
            dialogVisible: false,
            form: {
                id: '',
                title: '',
                content: '',
                send_message: '0',
                updated_at: '',
            },
            rules: {
                title: [{required: true, message: "请输入标题", trigger: "blur"}],
                send_message: [{required: true, message: "请选择弹窗提示", trigger: "change"}],
                content: [{required: true, message: "请输入正文", trigger: "blur"}],
            },
            check_id: ''
        }
    },

    created: function () {
        this.check_id = this.$route.query['id'];
        this.resetForm();
    },
    
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {};
            this.list = [];
            this.submitSearch();
        },

        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            KnowledgeBaseService.getList(params, 'index')
            .then((res) => {
                if (res.code == 0 && res.data.length > 0) {
                    this.list = res.data;
                    const node = this.check_id > 0 ? this.list.find(item => item.id == this.check_id) : this.list[0];
                    this.setCurrent(node)
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        showDialog(is_edit = false) {
            if(!is_edit) {
                this.form = {
                    id: '',
                    title: '',
                    content: '',
                    send_message: '0',
                    updated_at: ''
                };
            }
            this.is_edit = is_edit;
            this.dialogVisible = true;
        },


        //添加
        create() {
            this.$refs["form"].validate(valid => {
                this.form_loading = false;
                if (valid) {
                    let service = null;
                    if(this.is_edit){
                        service = KnowledgeBaseService.update(this.form)
                    }else{
                        service = KnowledgeBaseService.create(this.form)
                    }
                    service.then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: (this.is_edit ? '编辑' : '创建') + '成功',
                                type: 'success'
                            });
                            this.dialogVisible = false;
                            this.submitSearch();
                        }
                    })
                } else {
                    this.form_loading = false;
                    return false;
                }
            });
        },

        deleteItem(row) {
            this.$confirm("确认删除（" + row.title + "）吗？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                KnowledgeBaseService.delete(row.id)
                .then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.submitSearch();
                    }
                })
            }).catch((err) => {
                console.error(err);
            });
        },

        //选中行
        setCurrent(row) {
            this.form = row
            this.check_id = row.id;
            this.$refs.singleTable.setCurrentRow(row);
        },

        editorChange(value){
            this.form.content = value;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/knowledge-base/rule-list.vue